export enum MFAMethod {
    EMAIL = 'EMAIL',
    TOTP = 'TOTP',
    SMS = 'SMS',
}
